import { render, staticRenderFns } from "./Achievs.vue?vue&type=template&id=2aede312&scoped=true&"
import script from "./Achievs.vue?vue&type=script&lang=js&"
export * from "./Achievs.vue?vue&type=script&lang=js&"
import style0 from "./Achievs.vue?vue&type=style&index=0&id=2aede312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aede312",
  null
  
)

export default component.exports